<template>
  <span ref="rootRef" class="count-up">{{ formatted }}</span>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'

const props = defineProps({
  value: { type: Number, required: true },
  suffix: { type: String, default: '' },
  prefix: { type: String, default: '' },
  duration: { type: Number, default: 1600 },
})

const rootRef = ref(null)
const current = ref(0)
let observer
let rafId

const formatted = computed(() => `${props.prefix}${current.value}${props.suffix}`)

function animate() {
  const start = performance.now()
  const from = 0
  const to = props.value

  function tick(now) {
    const p = Math.min((now - start) / props.duration, 1)
    const eased = 1 - Math.pow(1 - p, 3)
    current.value = Math.round(from + (to - from) * eased)
    if (p < 1) {
      rafId = requestAnimationFrame(tick)
    } else {
      current.value = to
    }
  }

  rafId = requestAnimationFrame(tick)
}

onMounted(() => {
  observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        animate()
        observer?.disconnect()
      }
    },
    { threshold: 0.3 }
  )
  if (rootRef.value) observer.observe(rootRef.value)
})

onUnmounted(() => {
  observer?.disconnect()
  if (rafId) cancelAnimationFrame(rafId)
})
</script>

<style scoped>
.count-up {
  font-variant-numeric: tabular-nums;
}
</style>
